<dl class="mb-3">
  <dt class="mb-3">
    <strong>Działki</strong>
  </dt>
  <dd>
    <app-parcels-preview
      [planName]="planName()"
      [showIsEntireParcelCoveredByPlan]="true"
      [detailedInformation]="detailedInformation()"
      [parcels]="application()?.parcels || []">
    </app-parcels-preview>
  </dd>
</dl>
